// extracted by mini-css-extract-plugin
export var chip = "_48-0";
export var filterDropdown = "_48-5";
export var filterItem = "_48-6";
export var icon = "_48-1";
export var removeButton = "_48-3";
export var removeIcon = "_48-4";
export var separator = "_48-2";